export default __webpack_public_path__ + "static/media/README.c08c4efb.md";